"use client";

import { useEffect, useState } from "react";

interface UseMarginStickyProps {
  component: string;
}

const useMarginSticky = ({ component }: UseMarginStickyProps) => {
  const [margin, setMargin] = useState<number>(0);

  useEffect(() => {
    // Select all elements with data-component="header"
    const elements = document.querySelectorAll(component);
    // Select all child elements of these header elements
    const childElements = Array.from(elements).flatMap((element) => Array.from(element.children));

    let totalStickyHeight = 0;

    const observer = new IntersectionObserver(
      (entries) => {
        setMargin(0);
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            totalStickyHeight += entry.target.getBoundingClientRect().height;
          } else {
            totalStickyHeight -= entry.target.getBoundingClientRect().height;
          }
          setMargin(totalStickyHeight);
        });
      },
      { root: null, threshold: 1.0 },
    );

    childElements.forEach((element) => observer.observe(element));

    return () => {
      childElements.forEach((element) => observer.unobserve(element));
    };
  }, [margin]);

  return {
    margin,
  };
};

export default useMarginSticky;
